import { DOCUMENT, inject, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Global this, AKA window', {
    factory: () => {
        const { defaultView } = inject(DOCUMENT);
        return defaultView as Window & typeof globalThis;
    },
});
